import { createContext } from "react";

export const AdminDataContext = createContext();
